import { cn } from "@roman/shared/utils";
import { useNavigate } from "react-router-dom";

export const ComingSoonBadge = ({
  className,
  subClassName,
}: {
  className?: string;
  subClassName?: string;
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={cn("absolute -top-[14px] left-1/2 transform -translate-x-[50%]", className)}
      onClick={() => navigate("/top")}
    >
      <div
        className={cn(
          "rounded-full px-1 py-[2px] flex justify-center items-center bg-[#808080] space-x-1 h-[14px]",
          subClassName,
        )}
      >
        <span className={"text-white font-semibold text-[8px] leading-[8px] text-nowrap uppercase"}>
          Coming Soon
        </span>{" "}
      </div>
    </div>
  );
};
